/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

/* comma separated string of studio ids */
export const studioTagConfig = {
  'Jumpers.JumpersFitnessTld': 'JFBRANDEDWEBSITE-F1CF3D177FDD4A799F8BC4F5D44A4D7A',
  'Ai.AiFitnessTld': 'AIBRANDEDWEBSITE-16AA1907BA714194A361FDD2DC981B7A',
  SandboxStudio: 'MGM-924A845ED4D647FD81F7F4B40A2AF73B',
};
